// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2glNZ","index":"styles_index__2bq0N"};